<script>
import { euroCouponsThirdpartyMethods } from '@state/helpers'
import { required, email } from 'vuelidate/lib/validators'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import UsersManagement from '@components/roles_management/users/UsersManagement'

export default {
  name: 'EuroCouponsThirdpartyModal',
  components: { 
    DatePicker, UsersManagement,
    EuroCouponsThirdpartyForm: () => import('@components/euro_coupons/thirdparty/Form'), 
  },
  props: {
    fullform: {
      type: Boolean,
      required: false,
      default: false,
    },
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    onclose: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      action: 'create',
      euroCouponsThirdpartyOptions: [],
      form: {
        url: null,
        name: null,
        nit: null,
        contact_name: null,
        contact_email: null,
        payment_due_date: null,
        prefix_code: null,
        logo: null,
      },


      masks: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['YYYY-MM-DD', ], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
        data: ['YYYY-MM-DD'],
      },

      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
    }
  },
  validations: {
    form: {
      name: { required, },
      nit: { required, },
      contact_name: { required, },
      contact_email: { required, email },
      payment_due_date: { required, },
      prefix_code: { required, },
      logo: {  },
    },
  },
  computed: {},

  mounted: function () {
    let context = this
    context.form = {
      ...context.form, ...context.instanceJson,
    }
    if (context.instanceJson.url) {
      context.action = 'update'
      context.getObject()
    } else {
      context.action = 'create'
      context.loading = false
    }
  },

  methods: {
    ...euroCouponsThirdpartyMethods,

    getObject() {
      let context = this
      if (context.action == 'update') {
        const promise = context.fetchEuroCouponsThirdpartyDetail(context.form.url)
        return promise
          .then((data) => {
            context.form = { ...data }
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
          })
      }
    },

    submit() {
      let context = this
      context.submitting = true
      context.$v.form.$touch()
      if (context.$v.form.$invalid) {
        context.submitting = false
        context.$generate_toast(
          context,
          'error',
          context.$t('fill_the_required_fields')
        )
        return
      }
      const promise = context.createUpdateEuroCouponsThirdparty(context.form)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `${context.$t('thirdparty')} ${
              context.action == 'create' ? context.$t('created') : context.$t('updated')
            } ${context.$t('correctly')}`
          )
          context.instanceJson = { ...data }
          setTimeout(() => {
            context.oncomplete(data.url || null)
            context.submitting = false
          }, 2000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="
      action === 'create' ? `${$t('create')} ${$t('thirdparty')}` : `${$t('update')} ${$t('thirdparty')}`
    "
    hide-footer
    :size="action === 'create' ? 'lg' : 'lg'"
    @hidden="onclose"
    @ok.prevent="submit"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <!-- 
            Don't touch this generic form, if you need a custom form do 
            a v-else instead and code an alternative form :) 
          -->
          <b-tabs pills card justified>
            <b-tab title="Información Básica" active class="p-0">
              <b-card bg-variant="white" border-variant="info">
                <!-- <pre>
                  {{form}}
                </pre> -->
                <!-- <pre>
                  {{instanceJson}}
                </pre> -->
                <EuroCouponsThirdpartyForm
                :fullform="true"
                :instanceJson="instanceJson || {}"
                
                :oncomplete="
                  () => {
                    action = 'update'
                    // showForm = false;
                    // toUpdate = {};
                    // $refs.table.refresh()
                  }
                "
                :updateJson="
                  (data) => {
                    instanceJson = {...data}
                    action = 'update'
                    // showForm = false;
                    // toUpdate = {}
                  }
                "
              >
              </EuroCouponsThirdpartyForm>
              </b-card>
            </b-tab>
            <b-tab lazy :title="action === 'create'? '': 'Usuarios Asociados'" :disabled="action === 'create'">
            <UsersManagement
              :isthirdpartyuser="true"
              :thirdparty="instanceJson.url"
              :thirdpartyid="instanceJson.id"
              :create_user="true"
            />
            </b-tab>
          </b-tabs>

        </b-col>
      </b-row>
    </b-container>

    <!-- <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> {{ $t('saving') }} </span>
        <span v-else>
          <i class="fe-save"></i>
           {{ $t('save') }}
        </span>
      </b-button>
    </template> -->
  </b-modal>
</template>
<style lang="scss">
</style>